import {
  CheckCircleOutlineRounded,
  ErrorOutlineRounded,
} from '@material-ui/icons';

import { useSFStockoutItemChip } from './hooks';

import makeClasses from './SFStockoutItemChip.style';

export function SFStockoutItemChip(props: Props) {
  const { size = 'regular', mode } = props;

  const { lang, isStockout } = useSFStockoutItemChip({ mode });

  const TheIcon = isStockout ? ErrorOutlineRounded : CheckCircleOutlineRounded;

  const _classes = makeClasses({ size });

  return (
    <div
      role='status'
      aria-live='polite'
      aria-label='sf-stockout-item-chip'
      data-status-stockout={mode === 'stockout'}
      className={_classes.root}
    >
      <TheIcon aria-label='icon' />
      <span aria-label='label'>{lang.label}</span>
    </div>
  );
}

interface Props {
  // regular as default
  size?: 'small' | 'regular';
  mode: 'stockout' | 'replacement';
}
